import { Component } from '@angular/core';
import { TranslationPipe } from '@cloud-and-service/portal-lib';

@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.scss'],
    imports: [TranslationPipe],
})
export class AdminDashboardComponent {

  constructor() { }

}
